var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose2 = function SvgClose2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#989ca6",
    d: "m9.2 8 6.5-6.5c.4-.4.4-.9 0-1.2s-.9-.4-1.2 0L8 6.8 1.5.3C1.1-.1.6-.1.3.3s-.4.9 0 1.2L6.8 8 .3 14.5c-.4.4-.4.9 0 1.2q.3.3.6.3c.3 0 .4-.1.6-.3L8 9.2l6.5 6.5q.3.3.6.3t.6-.3c.4-.4.4-.9 0-1.2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose2);
export default ForwardRef;